<glxy-page [isLoading]="loading()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>
      @if (!payment()) {
        {{ 'PAYMENT_PAGE.PAGE_TITLE' | translate }}
      } @else {
        <ng-container>
          <span> {{ payment().amount | price: payment().currencyCode : null : true : false : true }}&nbsp; </span>
          {{ 'PAYMENT_PAGE.PAGE_TITLE' | translate }}
          <div class="status">
            <smb-invoicing-payment-status-chip
              [status]="payment().status"
              [disputeResponseDue]="payment().dispute?.evidenceDetails?.dueBy"
            ></smb-invoicing-payment-status-chip>
          </div>
        </ng-container>
      }
    </glxy-page-title>
    @if (payment()) {
      <glxy-page-actions>
        @if (shouldDisplayRefundButton()) {
          <button mat-stroked-button class="capitalize-content" (click)="onCreateRefundClicked(payment())">
            {{ 'PAYMENT_PAGE.REFUND' | translate }}
          </button>
        }

        @if (shouldDisplayAcceptDisputeButton()) {
          <button mat-stroked-button class="capitalize-content" (click)="onAcceptDisputeClicked()">
            {{ 'PAYMENT_PAGE.ACCEPT_DISPUTE' | translate }}
          </button>
        }

        @if (shouldDisplayProvideEvidenceButton()) {
          <a
            mat-flat-button
            color="primary"
            [routerLink]="['/billing/payments', payment().id, 'disputes', payment().dispute?.id]"
          >
            <span>
              {{ 'PAYMENT_PAGE.PROVIDE_EVIDENCE' | translate }}
            </span>
          </a>
        }

        @if (shouldDisplayViewEvidenceButton()) {
          <a
            mat-flat-button
            color="primary"
            [routerLink]="['/billing/payments', payment().id, 'disputes', payment().dispute?.id]"
          >
            <span>
              {{ 'PAYMENT_PAGE.VIEW_EVIDENCE' | translate }}
            </span>
          </a>
        }
      </glxy-page-actions>
    }
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="container">
      @if (errorCode()) {
        <mat-card appearance="outlined">
          <glxy-empty-state [size]="'small'">
            <glxy-empty-state-hero>
              <mat-icon>payments</mat-icon>
            </glxy-empty-state-hero>
            <glxy-empty-state-title>
              {{ 'PAYMENT_PAGE.ERROR_TITLE' | translate }}
            </glxy-empty-state-title>
            @if (errorCode() === 404) {
              <p>
                {{ 'PAYMENT_PAGE.NOT_FOUND' | translate }}
              </p>
            } @else {
              <p>
                {{ 'PAYMENT_PAGE.GENERAL_ERROR' | translate }}
              </p>
              <ng-container>
                <glxy-empty-state-actions>
                  <a mat-stroked-button [routerLink]="[paymentsPageLink()]">
                    {{ 'PAYMENT_PAGE.PAGE_TITLE' | translate }}
                  </a>
                </glxy-empty-state-actions>
              </ng-container>
            }
          </glxy-empty-state>
        </mat-card>
      }
      @if (
        !viewConfig().hideDisputeReference &&
        payment() &&
        payment().dispute &&
        needsResponseWarningStatuses.includes(payment().dispute.status)
      ) {
        <div class="section">
          <glxy-alert type="warning">
            <strong>
              {{ 'PAYMENT_PAGE.NEEDS_RESPONSE' | translate }}
            </strong>
            &mdash;
            {{ 'PAYMENT_PAGE.NEEDS_RESPONSE_DESCRIPTION' | translate }}
            {{ payment().dispute.evidenceDetails.dueBy | date: 'mediumDate' }}.
          </glxy-alert>
        </div>
      }
      @if (payment() && paymentOutstanding() !== null) {
        <div class="section">
          <smb-invoicing-payment-card
            [payment]="payment()"
            [paymentOutstanding]="paymentOutstanding()"
            [viewConfig]="{
              hideInvoiceReference: viewConfig().hideInvoiceReference,
              hideBusinessReference: viewConfig().hideBusinessReference,
            }"
          ></smb-invoicing-payment-card>
        </div>
      }
      <!-- Other card sections displayed here as provided by parent component -->
      <ng-content></ng-content>
    </div>
  </glxy-page-wrapper>
</glxy-page>
